import { render, staticRenderFns } from "./features-table.vue?vue&type=template&id=532ec271&scoped=true"
import script from "./features-table.vue?vue&type=script&lang=js"
export * from "./features-table.vue?vue&type=script&lang=js"
import style0 from "./features-table.vue?vue&type=style&index=0&id=532ec271&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ec271",
  null
  
)

export default component.exports